// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__Tfnh3","inputWrap":"Table_inputWrap__1WmaM","col":"Table_col__337aO","bmiTooltip":"Table_bmiTooltip__2F42V"};